import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'


export function getZhuantiList (query) {
    return fetchGet('/gateway/v1/topics', query)
}
export function uploadZhuantiFile (tosId,params) {
    return fetchPost('/gateway/v1/tos/'+tosId+'/topic-files', params, {
        'Content-Type': 'multipart/form-data'
    })
}
export function addTopics(params) {
    return fetchPost('/gateway/v1/topic', params)
}
export function deleteTopic (id,params) {
    return fetchDelete('/gateway/v1/topic/'+id,params)
}
export function topicDetail (id,params) {
    return fetchGet('/gateway/v1/topic/'+id,params)
}
export function changeTopic (id,params) {
    return fetchPut('/gateway/v1/topic/'+id,params)
}

export function topicModelList (params) { //专题模板
    return fetchGet('/gateway/v1/topic-templates',params)
}
export function deleteTopicModel(id) { //删除专题模板
    return fetchDelete('/gateway/v1/topic-templates/'+id)
}
export function addTopicModel(params) {
    return fetchPost('/gateway/v1/topic-templates', params)
}
export function uploadModelFile (tosId,params) {
    return fetchPost('/gateway/v1/tos/'+tosId+'/topic-template-file', params, {
        'Content-Type': 'multipart/form-data'
    })
}